import React from 'react';
import FixedWidthContainer from 'components/consumer/FixedWidthContainer';
import DesktopColumnsMobileStack from 'components/consumer/DesktopColumnsMobileStack/DesktopColumnsMobileStack';
import ImageTextBlock from 'components/essentials/ImageTextBlock';
import PropTypes from 'prop-types';

/*  Temporary copy of ImageBlocksTwo till dynamic column generation is added to Variant Builder
 */
const ImageBlocksThree = ({
  config: { heading, contentColumn1, contentColumn2, contentColumn3 },
}) => (
  <FixedWidthContainer className="ImageBlocksThree__container">
    {heading && heading.content && (
      <h3 className="text-3xl font-bold text-gray mt-0 mx-0 mb-10 text-left w-full">
        {heading.content}
      </h3>
    )}

    <DesktopColumnsMobileStack>
      <ImageTextBlock {...contentColumn1} />
      <ImageTextBlock {...contentColumn2} />
      <ImageTextBlock {...contentColumn3} />
    </DesktopColumnsMobileStack>
  </FixedWidthContainer>
);

ImageBlocksThree.propTypes = {
  config: PropTypes.shape({
    heading: PropTypes.string,
    contentColumn1: PropTypes.string,
    contentColumn2: PropTypes.string,
    contentColumn3: PropTypes.string,
  }),
};

export default ImageBlocksThree;
